import { motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

import theme from '../../../assets/theme';

type NotificationType = 'error' | 'warning';

const PoorInternetNotification = ({
  message,
  type,
}: {
  message: string;
  type: NotificationType;
}) => {
  return (
    <motion.div
      key="pwaInstallModal"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <InstallContainer $type={type}>
        <ExclamationContainer $type={type}>
          <span>!</span>
        </ExclamationContainer>
        <p style={{ whiteSpace: 'break-spaces' }}>{message}</p>
      </InstallContainer>
    </motion.div>
  );
};

const ExclamationContainer = styled.div<{ $type: NotificationType }>`
  color: ${theme.colors.white};
  border-radius: 50px;
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ $type }) =>
    $type === 'error' ? theme.colors.red : theme.colors.orange};
  flex: none;
  margin-right: 10px;
  span {
    font-weight: bold;
    font-size: 12px;
  }
`;
const InstallContainer = styled.div<{
  $type: NotificationType;
}>`
  position: absolute;
  bottom: 105px;
  left: 50%;
  width: 80%;
  transform: translateX(-50%);

  z-index: ${({ $type }) => ($type === 'error' ? 1500 : 1400)};
  max-width: 90%;
  border-left: 5px solid
    ${({ $type }) => ($type === 'error' ? theme.colors.red : theme.colors.orange)};
  background-color: ${theme.colors.white};
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  display: flex;
  align-items: center;
  padding: 8px 8px 8px 5px;
  border-radius: 5px;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.2);

  @media screen and (min-width: 500px) {
    max-width: 600px;
    width: fit-content;
    p {
      white-space: nowrap;
    }
  }

  p {
    color: ${theme.colors.black};
    font-weight: bold;
    flex: 1;
    margin-bottom: 0px;
    margin-top: 0px;

    word-break: break-word;
    font-size: 12px;
  }
`;

export default PoorInternetNotification;
